/**
 * Active actor cache — the ChooseChow customer↔chef role, held module-level so
 * the API client (`lib/api.ts`) can stamp it on every command synchronously,
 * exactly as edition scope is carried. `ChooseChowContext` keeps this in sync
 * with the resolved role; later it is derived from the authenticated profile's
 * classes + a backend `app_scope`.
 */
export type ChowRole = 'customer' | 'chef'

let current: ChowRole = 'customer'

export const getActiveRole = (): ChowRole => current

export const setActiveRole = (role: ChowRole): void => {
  current = role
}
